import {ENTER} from '@angular/cdk/keycodes';
import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	EventEmitter,
	HostBinding,
	HostListener,
	inject,
	Input,
	Output
} from '@angular/core';

@Component({
	selector: 'ui-icon-button',
	templateUrl: './button.component.html',
	styleUrls: ['./button.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class IconButtonComponent {
	private elementRef = inject(ElementRef);

	private focussed = false;

	@Input() icon: string;
	@Input() loading: boolean;
	@Input() help: string;

	@Output() action = new EventEmitter<MouseEvent>();

	@HostBinding('class.disabled') @Input() disabled: boolean;
	@HostBinding('class.ic-block') blockClass: boolean;
	@HostBinding('class.danger') dangerClass: boolean;
	@HostBinding('class.active') activeClass: boolean;
	@HostBinding('attr.tabIndex') tabIndex = 0;
	@HostBinding('class.warning') @Input() warning: boolean;

	@Input()
	set block(value: boolean) {
		this.blockClass = value;
	}
	@Input()
	set danger(value: boolean) {
		this.dangerClass = value;
	}
	@Input()
	set active(value: boolean) {
		this.activeClass = value;
	}

	get iconClass() {
		if (this.loading) {
			return 'fa fa-spin fa-refresh';
		}

		return this.icon;
	}

	@HostListener('keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		// Prevents auto-selecting the first item if focus was set by pressing enter on another item
		if (this.disabled || event.keyCode !== ENTER || this.focussed) {
			this.focussed = false;
			return;
		}

		this.action.emit(null);
	}

	focus() {
		this.focussed = true;
		this.elementRef.nativeElement.focus();
	}

	onClick(event: MouseEvent) {
		if (!this.disabled) {
			this.action.emit(event);
		}
	}
}
